import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import SignIn from "views/auth/SignIn";

// Icon Imports — using only icons confirmed present in older react-icons versions
import { MdLock, MdAccountBalance } from "react-icons/md";
import {
  HiOutlineOfficeBuilding,
  HiOutlineCog,
  HiDocumentReport,
} from "react-icons/hi";
import { RiBankCardLine } from "react-icons/ri";
import {
  TbArrowsExchange,
  TbReportMoney,
  TbRoute,
  TbUsers,
  TbUserShield,
  TbBuildingBank,
  TbCoinBitcoin,
  TbArrowAutofitDown,
  TbArrowAutofitUp,
  TbFileAnalytics,
  TbActivityHeartbeat,
  TbKey,
  TbListSearch,
  TbBan,
  TbSettings2,
  TbLayoutDashboard,
} from "react-icons/tb";
import { PiHandCoinsDuotone, PiUsersThree } from "react-icons/pi";
import { AiFillIdcard } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";

// Page Imports
import Organizations from "views/admin/organizations";
import Clients from "views/admin/clients";
import Customers from "views/admin/customers";
import Payments from "views/admin/payments";
import Users from "views/admin/users";
import SmartRoutings from "views/admin/smartrouting/SmartRoutings";
import PaymentMethod from "views/admin/paymentMethod";
import Settlement from "views/admin/settlement";
import SettlementSummary from "views/admin/settlement-summary";
import Subscription from "views/admin/subscription";
import Role from "views/admin/role";
import Payouts from "views/admin/payouts";
import CryptoPayout from "views/admin/crypto/payout";
import CryptoPayin from "views/admin/crypto/payin";
import FiatPayout from "views/admin/fiat/payout";
import API_tab from "views/admin/API_tab";
import ApiRequestLogs from "views/admin/ApiRequestLogs";
import KycVelocity from "views/admin/KycVelocity";
import { ViewLogs } from "views/admin/ViewLogs";
import BlackListClients from "views/admin/BlackList";
import Settings from "views/admin/Settings";
import AuditLogs from "views/admin/AuditLogs";
import ClientDetails from "views/admin/clients/components/ClientDetails";

/* Consistent icon wrapper */
const IC = (icon: React.ReactNode) => (
  <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
);

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    isHidden: false,
    icon: IC(<TbLayoutDashboard size={19} />),
    hideInSidebar: false,
    component: <MainDashboard />,
  },
  {
    name: "Clients",
    layout: "/admin",
    path: "clients",
    isHidden: false,
    icon: IC(<TbBuildingBank size={19} />),
    hideInSidebar: false,
    component: <Clients />,
  },
  {
    name: "Customers",
    layout: "/admin",
    path: "customers",
    isHidden: false,
    icon: IC(<PiUsersThree size={19} />),
    hideInSidebar: false,
    component: <Customers />,
  },
  {
    name: "Organizations",
    layout: "/admin",
    path: "organizations",
    isHidden: false,
    icon: IC(<HiOutlineOfficeBuilding size={19} />),
    hideInSidebar: false,
    component: <Organizations />,
  },
  {
    name: "Transactions",
    layout: "/admin",
    path: "transactions",
    isHidden: false,
    icon: IC(<TbArrowsExchange size={19} />),
    hideInSidebar: false,
    component: <Payments />,
  },
  {
    name: "Payout",
    layout: "/admin",
    path: "payout",
    isHidden: false,
    icon: IC(<PiHandCoinsDuotone size={19} />),
    hideInSidebar: false,
    component: <Payouts />,
  },
  {
    name: "Fiat Payout",
    layout: "/admin",
    path: "fiat-payout",
    isHidden: false,
    icon: IC(<TbReportMoney size={19} />),
    hideInSidebar: false,
    component: <FiatPayout />,
  },
  {
    name: "Gateways",
    layout: "/admin",
    path: "gateway",
    isHidden: false,
    icon: IC(<RiBankCardLine size={19} />),
    hideInSidebar: false,
    component: <PaymentMethod />,
  },
  {
    name: "Subscription",
    layout: "/admin",
    path: "subscription",
    isHidden: false,
    icon: IC(<TbActivityHeartbeat size={19} />),
    hideInSidebar: false,
    component: <Subscription />,
  },
  // {
  //   name: "Settlement",
  //   layout: "/admin",
  //   path: "settlement",
  //   isHidden: false,
  //   icon: IC(<MdAccountBalance size={19} />),
  //   hideInSidebar: false,
  //   component: <Settlement />,
  // },
  {
    name: "Settlement",
    layout: "/admin",
    path: "submenu",
    icon: IC(<MdAccountBalance size={19} />),
    children: [
      {
        name: "View Settlements",
        layout: "/admin",
        path: "settlement",
        icon: IC(<MdAccountBalance size={17} />),
        component: <Settlement />,
      },
      {
        name: "Settlement Summary",
        layout: "/admin",
        path: "settlement-summary",
        icon: IC(<MdAccountBalance size={17} />),
        component: <SettlementSummary />,
      },
    ],
  },
  {
    name: "Crypto",
    layout: "/admin",
    path: "submenu",
    icon: IC(<TbCoinBitcoin size={19} />),
    children: [
      {
        name: "Payout",
        layout: "/admin",
        path: "crypto-payout",
        icon: IC(<TbArrowAutofitUp size={17} />),
        component: <CryptoPayout />,
      },
      {
        name: "Payin",
        layout: "/admin",
        path: "crypto-payin",
        icon: IC(<TbArrowAutofitDown size={17} />),
        component: <CryptoPayin />,
      },
    ],
  },
  {
    name: "Platform Management",
    layout: "/admin",
    path: "submenu",
    icon: IC(<TbSettings2 size={19} />),
    children: [
      {
        name: "Users",
        layout: "/admin",
        path: "users",
        icon: IC(<TbUsers size={17} />),
        component: <Users />,
      },
      {
        name: "Audit Logs",
        layout: "/admin",
        path: "audit-logs",
        icon: IC(<TbFileAnalytics size={17} />),
        component: <AuditLogs />,
      },
      {
        name: "Role",
        layout: "/admin",
        path: "role",
        icon: IC(<TbUserShield size={17} />),
        component: <Role />,
      },
      {
        name: "API Access",
        layout: "/admin",
        path: "api",
        icon: IC(<TbKey size={17} />),
        component: <API_tab />,
      },
      {
        name: "API Request Logs",
        layout: "/admin",
        path: "request-logs",
        icon: IC(<TbListSearch size={17} />),
        component: <ApiRequestLogs />,
      },
      {
        name: "Blacklist",
        layout: "/admin",
        path: "blacklist",
        icon: IC(<TbBan size={17} />),
        component: <BlackListClients />,
      },
      {
        name: "Kyc Velocity",
        layout: "/admin",
        path: "kyc-velocity",
        icon: IC(<AiFillIdcard size={17} />),
        component: <KycVelocity />,
      },
      {
        name: "Settings",
        layout: "/admin",
        path: "settings",
        icon: IC(<HiOutlineCog size={17} />),
        component: <Settings />,
      },
    ],
  },
  {
    name: "View Logs",
    layout: "/admin",
    path: "logs",
    isHidden: false,
    icon: IC(<HiDocumentReport size={19} />),
    hideInSidebar: false,
    component: <ViewLogs />,
  },
  {
    name: "Smart Routing",
    layout: "/admin",
    path: "client-details/:id?",
    isHidden: false,
    icon: IC(<TbRoute size={19} />),
    hideInSidebar: false,
    component: <ClientDetails />,
  },
  {
    name: "Smart Routing",
    layout: "/admin",
    path: "smart-routing/:id?",
    isHidden: false,
    icon: IC(<TbRoute size={19} />),
    hideInSidebar: false,
    component: <SmartRoutings />,
  },
  {
    name: "My Profile",
    layout: "/admin",
    path: "profile",
    isHidden: true,
    icon: IC(<FaUserCircle size={19} />),
    component: <Profile />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    isHidden: false,
    icon: IC(<MdLock size={19} />),
    component: <SignIn />,
  },
];

export default routes;